import React from "react";
import { auth } from "../firebase";
import { NavLink } from "react-router-dom";

const SignOutButton = () => (
  // <button type="button" onClick={auth.doSignOut}>
  //   Sign Out
  // </button>
  <a className="waves-effect waves-light btn red" onClick={auth.doSignOut} style={{display:"flex"}}>
    <i className="material-icons left" style={{float:"left"}}>exit_to_app</i><p>Sign Out</p>
  </a>
);
export default SignOutButton;
